import React, {} from 'react';
import { joinClassNames } from './joinClassNames.js';
const styles = {"section":"Section-module__section__KZmpV","surfaceGround":"Section-module__surfaceGround__Bdunr","surfaceSurface":"Section-module__surfaceSurface__HR6-m","surfaceTint":"Section-module__surfaceTint__eRDHO","column":"Section-module__column__zxx3E","content":"Section-module__content__6Oju3","widthNarrow":"Section-module__widthNarrow__nGP6V","widthWide":"Section-module__widthWide__n3XIu","title":"Section-module__title__JlvAT"};
const SURFACE_CLASS_NAMES = {
    ground: styles.surfaceGround,
    surface: styles.surfaceSurface,
    tint: styles.surfaceTint
};
const WIDTH_CLASS_NAMES = {
    narrow: styles.widthNarrow,
    wide: styles.widthWide
};
/** A full-width band of the landing page with its own background, an optional title and a centered column. */
export function Section({ id, title, surface = 'ground', width = 'wide', children }) {
    const titleId = `${id}-title`;
    let heading;
    if (title !== undefined) {
        heading = (React.createElement("h2", { className: styles.title, id: titleId }, title));
    }
    return (React.createElement("section", { className: joinClassNames(styles.section, SURFACE_CLASS_NAMES[surface]), id: id, "aria-labelledby": heading === undefined ? undefined : titleId },
        React.createElement("div", { className: joinClassNames(styles.column, WIDTH_CLASS_NAMES[width]) },
            heading,
            React.createElement("div", { className: styles.content }, children))));
}
//# sourceMappingURL=Section.js.map